/**
 * CategoryPage.tsx — 分类页
 * 按分类 slug 浏览该分类下的全部 Prompts。
 */
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { getCategories, getPrompts } from '../lib/api';
import { categoryName } from '../data/seed';
import type { Prompt, Category } from '../data/seed';
import PromptCard from '../components/PromptCard';
import { Loading, EmptyState } from '../components/States';

export default function CategoryPage() {
  const { slug = '' } = useParams();
  const [prompts, setPrompts] = useState<Prompt[]>([]);
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      const [cats, list] = await Promise.all([
        getCategories(),
        getPrompts({ category: slug, sort: 'latest', limit: 50 }),
      ]);
      if (cancelled) return;
      setCategories(cats);
      setPrompts(list);
      setLoading(false);
    }
    void load();
    return () => {
      cancelled = true;
    };
  }, [slug]);

  const matched = categories.find((c) => c.slug === slug);
  const title = matched?.name ?? categoryName(slug);

  return (
    <div className="space-y-6">
      <div className="rounded-2xl bg-gradient-to-r from-indigo-600 to-violet-600 p-6 text-white shadow-md">
        <Link to="/" className="text-sm text-indigo-200 transition hover:text-white">
          ← 返回首页
        </Link>
        <h1 className="mt-2 text-2xl font-bold">{title}</h1>
        <p className="mt-1 text-sm text-indigo-100">共 {matched?.count ?? prompts.length} 条 Prompt</p>
      </div>

      {loading ? (
        <Loading />
      ) : prompts.length === 0 ? (
        <EmptyState message="该分类下暂时没有内容" />
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {prompts.map((prompt) => (
            <PromptCard key={prompt.id} prompt={prompt} />
          ))}
        </div>
      )}
    </div>
  );
}
